import React from 'react'
import { CaseStudy } from '../../api/Types'

interface Props {
  readonly case_study: CaseStudy
}

const DocsCaseStudyListItem: React.FunctionComponent<Props> = ({
  case_study: { title, title_image, url_slug, company, description, read_time_minutes_text },
}) => {
  return (
    <a className='case-study-list-item' href={`/customer-stories/${url_slug}`}>
      <div className='case-study-list-item-image-wrapper'>
        <img className='case-study-list-item-image' src={title_image} alt={title} />
      </div>
      <div className='case-study-list-item-content'>
        <div className='case-study-list-item-company'>{company}</div>
        <h2 className='case-study-list-item-title'>{title}</h2>
        <p className='case-study-list-item-description'>{description}</p>
      </div>
      <div className='case-study-list-item-footer'>
        {read_time_minutes_text && (
          <span className='case-study-list-item-footer-note'>{read_time_minutes_text}</span>
        )}
      </div>
    </a>
  )
}

export default DocsCaseStudyListItem
